import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChangelogDialog } from "@/components/ChangelogDialog";
import api from "@/lib/api";

const MAX_ITEMS = 5;

export default function WhatsNewDialog() {
  const [release, setRelease] = useState(null);
  const [showLog, setShowLog] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("emulating_from")) return;
    const t = setTimeout(() => api.get("/whats-new").then(r => r.data.show && setRelease(r.data.release)).catch(() => {}), 1500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = (openLog) => {
    api.post("/whats-new/seen").catch(() => {});
    setRelease(null);
    if (openLog) setShowLog(true);
  };

  return (
    <>
      <Dialog open={!!release} onOpenChange={(o) => !o && dismiss(false)}>
        {release && (
          <DialogContent className="bg-bt-surface border-bt-gold/40 max-w-md" data-testid="whats-new-dialog">
            <DialogHeader>
              <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-bt-gold">
                <Sparkles className="w-3.5 h-3.5" /> {release.version} · {release.date}
              </div>
              <DialogTitle className="font-display text-2xl text-bt-text-primary" data-testid="whats-new-title">What's new in {release.version}</DialogTitle>
              <DialogDescription className="font-body text-sm text-bt-text-secondary">{release.title}</DialogDescription>
            </DialogHeader>
            <ul className="space-y-2 mt-1" data-testid="whats-new-list">
              {release.changes.slice(0, MAX_ITEMS).map(c => (
                <li key={c} className="flex gap-2 text-sm text-bt-text-primary font-body leading-snug">
                  <span className="mt-1.5 w-1.5 h-1.5 bg-bt-gold shrink-0" />{c}
                </li>
              ))}
            </ul>
            {release.changes.length > MAX_ITEMS && (
              <p className="text-xs font-mono text-bt-text-tertiary">+{release.changes.length - MAX_ITEMS} more improvements</p>
            )}
            <div className="flex items-center justify-between mt-2">
              <button onClick={() => dismiss(true)} className="text-xs font-mono text-bt-text-secondary hover:text-bt-gold underline underline-offset-4" data-testid="whats-new-full-changelog">
                Full changelog
              </button>
              <Button onClick={() => dismiss(false)} className="bg-bt-gold text-bt-bg hover:opacity-90" data-testid="whats-new-dismiss">Got it</Button>
            </div>
          </DialogContent>
        )}
      </Dialog>
      <ChangelogDialog open={showLog} onOpenChange={setShowLog} />
    </>
  );
}
